export default __webpack_public_path__ + "static/media/Gids-vir-die-Naasbestaandes_29Jun2017.edb5c472.pdf";